import React from 'react';
import { Section } from './Section';
import { Layers, ShieldCheck, Truck, Workflow, BarChart3 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Mechanism() {
  const pillars = [{
    num: '01',
    title: 'Arquitectura ecommerce',
    desc: 'Estructura de tienda, categorías, productos, navegación, páginas clave y flujo de compra diseñados para vender, no solo para mostrarse.',
    icon: <Layers className="w-6 h-6 text-navy-900" data-id="element-275" />
  }, {
    num: '02',
    title: 'Conversión y confianza',
    desc: 'Presentación profesional de productos, elementos de credibilidad, journey de compra claro y experiencia mobile-first.',
    icon: <ShieldCheck className="w-6 h-6 text-navy-900" data-id="element-276" />
  }, {
    num: '03',
    title: 'Pagos, despacho y operación',
    desc: 'Medios de pago configurados, lógica de despacho, gestión de productos e infraestructura operativa lista para funcionar.',
    icon: <Truck className="w-6 h-6 text-navy-900" data-id="element-277" />
  }, {
    num: '04',
    title: 'Automatización y seguimiento',
    desc: 'Base para recuperar clientes interesados, ordenar consultas y preparar acciones futuras de email, WhatsApp y remarketing.',
    icon: <Workflow className="w-6 h-6 text-navy-900" data-id="element-278" />
  }, {
    num: '05',
    title: 'Medición comercial',
    desc: 'Estructura de analítica configurada para entender visitas, comportamiento, productos y oportunidades comerciales.',
    icon: <BarChart3 className="w-6 h-6 text-navy-900" data-id="element-279" />
  }];
  return <section className="relative py-16 md:py-24 bg-navy-950 text-white overflow-hidden" data-id="element-280">
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-900 to-navy-950" data-id="element-281"></div>
      <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-accent/15 blur-[140px] rounded-full" data-id="element-282"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-283">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-284">
          <span className="text-accent font-bold tracking-wider text-sm uppercase mb-3 block" data-id="element-285">
            El sistema
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6" data-id="element-286">
            BitzenEscala™: el sistema ecommerce profesional automatizado para
            lanzar tu canal online{' '}
            <span className="text-accent" data-id="element-287">con estructura</span>
          </h2>
          <p className="text-lg text-slate-300" data-id="element-288">
            BitzenEscala™ no es un pack de diseño web. Es un sistema de
            implementación ecommerce profesional para pymes retail que necesitan
            un canal de ventas online serio, ordenado y preparado para escalar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-289">
          {pillars.map((pillar, i) => <div key={i} className="bg-navy-900/80 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-accent/50 hover:shadow-glow transition-all duration-300" data-id="element-290">
              <div className="flex items-center justify-between mb-6" data-id="element-291">
                <div className="bg-accent w-12 h-12 rounded-xl flex items-center justify-center shadow-glow" data-id="element-292">
                  {pillar.icon}
                </div>
                <span className="text-2xl font-heading font-bold text-accent/40" data-id="element-293">
                  {pillar.num}
                </span>
              </div>
              <h3 className="text-xl font-heading font-bold text-white mb-4" data-id="element-294">
                {pillar.title}
              </h3>
              <p className="text-slate-300 leading-relaxed text-sm" data-id="element-295">
                {pillar.desc}
              </p>
            </div>)}
        </div>

        
      </div>
    </section>;
}